export default __webpack_public_path__ + "static/media/Stripes.caf2be40.svg";